/* Native scroll, keyboard controls and race-safe on-demand previews. */
(() => {
  'use strict';
  if (window.FDEditorial) return;
  const roots = new Map();
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const reduced = () => motion.matches;
  function init(root) {
    if (roots.has(root)) return;
    const lifecycle = new AbortController(), signal = lifecycle.signal;
    const setViewport = () => root.style.setProperty('--fd-ed-viewport', document.documentElement.clientWidth + 'px');
    setViewport();
    window.addEventListener('resize', setViewport, {passive:true,signal});
    const track = root.querySelector('.fded-track');
    const cards = [...track.querySelectorAll('.fded-card:not(.fded-endcard)')].sort((a,b) => +(a.dataset.prio??9999) - +(b.dataset.prio??9999));
    const endCard=track.querySelector('.fded-endcard');cards.forEach(c=>track.append(c));if(endCard)track.append(endCard);
    const prev = root.querySelector('[data-fded-prev]'), next = root.querySelector('[data-fded-next]');
    const edgeNext = null, autoplay = root.querySelector('[data-fded-autoplay]');
    const counter = root.querySelector('[data-fded-count]'), bar = root.querySelector('[data-fded-progress]');
    const panel = root.querySelector('.fded-prods'), grid = root.querySelector('.fded-ptrack'), status = root.querySelector('[data-fded-status]');
    const all = root.querySelector('.fded-all'), cache = new Map();
    let request, selected, frame;
    let timer = 0, slideTimer = 0, visible = false, paused = false, hovered = false, touching = false, direction = 1;
    const canPlay = () => false;
    const normalize=value=>String(value||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[^a-z0-9]+/g,' ').trim();
    let movingUntil=0;
    const interaction=()=>{movingUntil=Date.now()+700;};
    window.addEventListener('scroll',interaction,{passive:true,signal});
    track.addEventListener('scroll',interaction,{passive:true,signal});
    function rotateFrames(){
      if(!visible||document.hidden||reduced()||!matchMedia('(hover:hover) and (pointer:fine)').matches||Date.now()<movingUntil)return;
      cards.forEach(card=>{
        if(card.dataset.id==='club-real-madrid'||card.dataset.id==='club-fc-barcelone')return;
        const frames=[...card.querySelectorAll('.fded-frame')];if(frames.length<2)return;
        let index=frames.findIndex(frame=>frame.classList.contains('is-active'));if(index<0)index=0;
        frames[index].classList.remove('is-active');frames[(index+1)%frames.length].classList.add('is-active');
      });
    }
    const frameVisibility=new IntersectionObserver(entries=>{
      if(!matchMedia('(hover:hover) and (pointer:fine)').matches)return;
      for(const entry of entries)if(entry.isIntersecting){
        entry.target.querySelectorAll('template[data-fded-frame]').forEach(template=>template.replaceWith(template.content));
        frameVisibility.unobserve(entry.target);
      }
    },{rootMargin:'160px'});
    cards.forEach(card=>frameVisibility.observe(card));
    slideTimer=setInterval(rotateFrames,3500);
    function arm() {
      clearTimeout(timer);timer=0;
      const playing=canPlay();
      root.dataset.editorialPlayback=playing?'playing':'paused';
      counter.setAttribute('aria-live',playing?'off':'polite');
      if(!playing)return;
      timer=setTimeout(()=>{
        if(!canPlay()){arm();return;}
        const max=track.scrollWidth-track.clientWidth;
        if(track.scrollLeft>=max-3)direction=-1;
        else if(track.scrollLeft<=3)direction=1;
        step(direction);arm();
      },5000);
    }
    function syncAutoplay() {
      if(autoplay){
        autoplay.hidden=reduced();
        autoplay.setAttribute('aria-pressed',String(paused));
        const label=paused?autoplay.dataset.resumeLabel:autoplay.dataset.pauseLabel;
        autoplay.setAttribute('aria-label',label);autoplay.title=label;
      }
      arm();
    }
    root.querySelectorAll('[data-fded-controls],[data-fded-preview]').forEach(e=>e.hidden=false);
    let geometry={width:1,total:1,padding:0,boxes:[]};
    function measure(){
      const box=track.getBoundingClientRect(),position=track.scrollLeft;
      geometry={width:track.clientWidth,total:track.scrollWidth,padding:parseFloat(getComputedStyle(track).paddingLeft)||0,boxes:cards.map(card=>{const b=card.getBoundingClientRect();return {left:b.left-box.left+position,right:b.right-box.left+position};})};
      sync();
    }
    function sync(){
      frame=0;
      const {width,total:totalWidth,padding,boxes}=geometry,max=totalWidth-width,position=Math.max(0,track.scrollLeft);
      let nearest=0,distance=Infinity,firstVisible=-1,lastVisible=-1;
      boxes.forEach((box,index)=>{
        const delta=Math.abs(box.left-position-padding);
        if(delta<distance){distance=delta;nearest=index;}
        if(box.left>=position-1&&box.right<=position+width+1){if(firstVisible<0)firstVisible=index;lastVisible=index;}
      });
      const firstIndex=(firstVisible<0?nearest:firstVisible)+1,lastIndex=(lastVisible<0?nearest:lastVisible)+1;
      const text=firstIndex+(lastIndex>firstIndex?'–'+lastIndex:'')+' / '+cards.length,atStart=position<3,atEnd=position>=max-3;
      if(prev.disabled!==atStart)prev.disabled=atStart;if(next.disabled!==atEnd)next.disabled=atEnd;
      if(counter.textContent!==text)counter.textContent=text;
      const ratio=totalWidth>0?Math.min(1,width/totalWidth):1,barWidth=(ratio*100)+'%',transform='translateX('+(max>0&&ratio>0?position/max*(1-ratio)/ratio*100:0)+'%)';
      if(bar.style.width!==barWidth)bar.style.width=barWidth;if(bar.style.transform!==transform)bar.style.transform=transform;
    }
    function step(direction) {
      track.scrollBy({left:direction*(cards[0].offsetWidth+parseFloat(getComputedStyle(track).gap)),behavior:reduced()?'auto':'smooth'});
    }
    function manualStep(value){direction=value;step(value);arm();}
    prev.addEventListener('click',()=>manualStep(-1),{signal});next.addEventListener('click',()=>manualStep(1),{signal});
    edgeNext?.addEventListener('click',()=>manualStep(1),{signal});
    autoplay?.addEventListener('click',()=>{paused=!paused;syncAutoplay();},{signal});
    root.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse'){hovered=true;arm();}},{signal});
    root.addEventListener('pointerleave',event=>{if(event.pointerType==='mouse'){hovered=false;arm();}},{signal});
    root.addEventListener('pointerdown',()=>{touching=true;arm();},{passive:true,signal});
    const release=()=>{if(touching){touching=false;arm();}};
    window.addEventListener('pointerup',release,{passive:true,signal});
    window.addEventListener('pointercancel',release,{passive:true,signal});
    root.addEventListener('focusin',arm,{signal});
    root.addEventListener('focusout',()=>queueMicrotask(arm),{signal});
    track.addEventListener('wheel',arm,{passive:true,signal});
    document.addEventListener('visibilitychange',arm,{signal});
    window.addEventListener('pagehide',()=>{clearTimeout(timer);timer=0;},{signal});
    window.addEventListener('pageshow',arm,{signal});
    motion.addEventListener('change',syncAutoplay,{signal});
    track.addEventListener('scroll',()=>{if(!frame)frame=requestAnimationFrame(sync)},{passive:true,signal});
    track.addEventListener('keydown',e=>{
      if(e.target!==track)return;
      if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();manualStep(e.key==='ArrowRight'?1:-1)}
      if(e.key==='Home'||e.key==='End'){e.preventDefault();track.scrollTo({left:e.key==='Home'?0:track.scrollWidth,behavior:reduced()?'auto':'smooth'});arm();}
    },{signal});
    function render(items,url) {
      grid.replaceChildren();all.href=url;
      status.textContent=items.length?'Un aperçu de la collection · saisons récentes en premier':'La sélection est disponible dans la collection.';
      for(const item of items){
        const a=document.createElement('a');a.className='fded-mini';a.href=item.href;
        if(item.image){const img=document.createElement('img');img.src=item.image;img.alt=item.title;img.loading='lazy';img.width=240;img.height=240;a.append(img)}
        for(const [cls,value] of [['t',item.title],['p',item.price]]){const span=document.createElement('span');span.className=cls;span.textContent=value;a.append(span)}
        grid.append(a);
      }
    }
    root.addEventListener('click',async e=>{
      const button=e.target.closest('[data-fded-preview]');if(!button)return;
      const card=button.closest('.fded-card');request?.abort();
      root.querySelectorAll('[data-fded-preview]').forEach(b=>b.setAttribute('aria-expanded','false'));
      if(selected===card){selected=null;panel.hidden=true;panel.removeAttribute('aria-busy');return}
      selected=card;button.setAttribute('aria-expanded','true');panel.hidden=false;panel.setAttribute('aria-busy','true');
      grid.replaceChildren();status.textContent='Chargement des maillots…';all.href=card.dataset.url;
      const active=new AbortController();request=active;
      const timeout=setTimeout(()=>active.abort(),12000);
      try{
        const url=new URL(card.dataset.url,location.origin);
        if(url.origin!==location.origin)throw new Error('External collection');
        url.searchParams.set('sort_by','manual');
        if(cache.has(url.href)){render(cache.get(url.href),card.dataset.url);return}
        const response=await fetch(url,{signal:active.signal,credentials:'same-origin'});
        if(!response.ok)throw new Error('Collection unavailable');
        const doc=new DOMParser().parseFromString(await response.text(),'text/html');
        const nodes=[...doc.querySelectorAll('.fdc-grid > .fdc-card')].sort((a,b)=>+(b.dataset.score||0)-+(a.dataset.score||0));
        const items=nodes.slice(0,4).map(node=>{
          const a=node.querySelector('a[href*="/products/"]'), img=node.querySelector('img');
          return {href:a?.getAttribute('href'),image:img?.getAttribute('src')||'',title:node.querySelector('[class*="card-t"]')?.textContent.trim()||img?.alt||'',price:node.querySelector('.fdc-price-now')?.textContent.trim()||''};
        }).filter(item=>item.href&&item.title);
        if(active.signal.aborted||request!==active||selected!==card||!root.isConnected)return;
        cache.set(url.href,items);render(items,card.dataset.url);
      }catch(error){
        if(request===active&&selected===card){status.textContent='L’aperçu est indisponible. Tu peux ouvrir la collection ci-dessous.';grid.replaceChildren()}
      }finally{clearTimeout(timeout);if(request===active&&selected===card)panel.setAttribute('aria-busy','false')}
    },{signal});
    function sourceContext(element){
      if(!element)return '';
      const href=element.matches('a')?element.getAttribute('href'):(element.querySelector('a[href]')?.getAttribute('href')||'');
      return normalize((element.dataset.fdTitle||'')+' '+(element.dataset.fdTags||'')+' '+(element.textContent||'')+' '+href);
    }
    function matchEditorial(context){
      if(!context)return null;
      const productHandle=(context.match(/products ([a-z0-9 ]+)/)||[])[1]||'';
      for(const card of cards){
        const key=normalize(card.dataset.syncKey),extra=normalize(card.dataset.syncContext);
        if(key&&(context.includes(key)||key.includes(context)))return card;
        if(productHandle&&extra.includes(productHandle))return card;
      }
      return null;
    }
    function scrollEditorial(card){
      if(!card)return;
      const pad=parseFloat(getComputedStyle(track).paddingLeft)||0;
      const left=Math.max(0,card.offsetLeft-pad);
      if(Math.abs(track.scrollLeft-left)>4)track.scrollTo({left,behavior:reduced()?'auto':'smooth'});
      cards.forEach(item=>item.classList.toggle('is-synced',item===card));
    }
    function syncFromSource(sourceTrack){
      if(!sourceTrack||!sourceTrack.classList.contains('fdgc-bsrow'))return;
      const selector='[data-fd-product-card]:not([hidden])';
      const items=[...sourceTrack.querySelectorAll(selector)];if(!items.length)return;
      const box=sourceTrack.getBoundingClientRect(),target=box.left+box.width*.44;
      let nearest=null,distance=Infinity;
      for(const item of items){
        const b=item.getBoundingClientRect();if(b.right<box.left||b.left>box.right)continue;
        const d=Math.abs((b.left+b.right)/2-target);if(d<distance){distance=d;nearest=item;}
      }
      const active=nearest||items[0];
      const context=sourceContext(active);
      if(/\breal madrid\b/.test(context)||/\bfc barcelone\b/.test(context)||/\bbarcelone\b/.test(context))return;
      const matched=matchEditorial(context);
      if(matched?.dataset.id==='club-real-madrid'||matched?.dataset.id==='club-fc-barcelone')return;
      scrollEditorial(matched);
    }
    const sourceSection=root.previousElementSibling;
    const sourceCleanups=[];
    if(sourceSection){
      const sourceTrack=sourceSection.querySelector('.fdgc-bsrow');
      if(sourceTrack){
        let syncFrame=0,syncTimer=0;
        const onSource=()=>{
          clearTimeout(syncTimer);
          syncTimer=setTimeout(()=>{
            if(!syncFrame)syncFrame=requestAnimationFrame(()=>{syncFrame=0;syncFromSource(sourceTrack);});
          },110);
        };
        sourceTrack.addEventListener('scroll',onSource,{passive:true,signal});
        sourceTrack.addEventListener('pointerup',onSource,{passive:true,signal});
        sourceCleanups.push(()=>{clearTimeout(syncTimer);cancelAnimationFrame(syncFrame);});
        setTimeout(()=>syncFromSource(sourceTrack),120);
      }
    }
        const resize=new ResizeObserver(()=>{measure();arm();});resize.observe(track);measure();
    const visibility=new IntersectionObserver(entries=>{
      for(const entry of entries){visible=entry.isIntersecting&&entry.intersectionRatio>=.2;arm();}
    },{threshold:[0,.2]});
    visibility.observe(track);syncAutoplay();
    roots.set(root,()=>{lifecycle.abort();request?.abort();resize.disconnect();visibility.disconnect();frameVisibility.disconnect();clearTimeout(timer);clearInterval(slideTimer);sourceCleanups.forEach(fn=>fn());cancelAnimationFrame(frame)});
  }
  function start(scope=document){scope.querySelectorAll('.fded-v3').forEach(init)}
  window.FDEditorial={start};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>start(),{once:true});else start();
  document.addEventListener('shopify:section:load',()=>start());
  document.addEventListener('shopify:section:unload',e=>{for(const [root,destroy]of roots)if(e.target.contains(root)){destroy();roots.delete(root)}});
})();
